import { connect } from 'react-redux';
import ConfigureModalsModal from './ConfigureModalsModal';
import { saveBootcamp } from '../../../actions/bootcampActions';

export default connect(null, { saveBootcamp })(ConfigureModalsModal);
